export const DOCS_META = {
  badge: 'ANGULAR 21 FAMILY',
  angularVersion: '21.0.0 -> 21.2.8',
  packageVersion: '6.0.3',
  packageRange: '6',
  docsPath: 'angular-21'
};
